export interface IMaintenance {
  isActive: boolean;
  message?: string;
}

export class MaintenanceDto implements IMaintenance {
  constructor(
    public isActive: boolean,
    public message?: string
  ) {
  }
}
